import { defineStore } from '@core/utils/vuex'
import { createRequestBuilder } from '@/@core/utils/object'

export default defineStore({
    namespaced: true,
    state: {},
    actions: createRequestBuilder()
        .qGet('fetchReporteBalanceComprobacion', '/api/auth/contabilidad/balance-comprobacion')
        .addGet('downloadExcelBalanceComprobacion', {
            route: '/api/auth/contabilidad/balance-comprobacion/excel',
            axiosSettings: { responseType: 'blob' },
        })
        .qGet('fetchReporteBalanceGeneral', '/api/auth/v2/contabilidad/reportes/balance-general')
        .addGet('downloadExcelBalanceGeneral', {
            route: '/api/auth/contabilidad/balance-general/excel',
            axiosSettings: { responseType: 'blob' },
        })
        .build(),
})
